/*
 * @Author: liujuan@codoon.com 
 * @Date: 2022-03-16 14:37:51 
 * @Last Modified by: liujuan@codoon.com
 * @Last Modified time: 2022-03-16 14:37:51 
 */

/**
 * url中的参数：
 * activityId：要返回的跳转id
 *
 * 完整链接实例：
 * https://www.codoon.com/activity/club/signGroup?activityId=420
 */
import React, {
  FC,
  memo,
  useCallback,
  useEffect,
  useState,
  useLayoutEffect,
} from "react";
import giftIcon from "../../assets/imgs/icon_challenge_gift@2x.png";
import "./index.less";
import { UrlFun } from "codoon-fun";
import { navigate } from "@reach/router"; 
import classNames from "classnames";
import { keep2Decimal } from "../../utils/number";
import Modal from "../../components/Common/Modal/Modal";
import styles from "./index.style";
import { Toast, Loading } from "codoon-come";
import ActivityApi from "../../service/activity";
import { useShowToast } from "../../hooks/utilHooks";
import { IActivityInfo } from "../../service/activity/interface";
import indexService  from "../../service/Index";
import { isIosBangsDevice } from "../../utils/system";
import { recordSc } from "../utils";
import { addNativeReturnListener, isInCodoon } from "../../utils/bridge";

const { GlobalToast } = Toast;

const PREFIX = "SignGroup";

const urlParams = UrlFun.getUrlParams(window.location.href) as any as IUrlParam;

interface IUrlParam {
  activityId: string;
  goalId: string;
}

const SignGroup = memo(() => {
  const [activityInfo, setActivityInfo] = useState<IActivityInfo>();
  const [check, setCheck] = useState<Boolean>(false);
  const [goods_id, setGoodsid] = useState<string>('');
  const { toastVisible, toastTip, showToast } = useShowToast();

  useLayoutEffect(() => {
    document.title = "选择报名套餐";
  }, []);

  useEffect(() => {
    // 获取报名套餐接口
    getMyActivity();

    return () => {
      recordScFun();
    };
  }, [])
  
  const recordScFun = useCallback(() => {
    const { activityId } = urlParams;

    // 埋点
    recordSc({
      event: '$WebClick',
      data: {
        btn_name: '返回按钮',
        click_name: '返回',
        in_page_name: '报名套餐页',
        in_page_path: activityInfo?.name + '挑战-报名套餐页',
        ext: activityId
      }
    })
  }, []);
  
  const onSelect = useCallback(() => {
    setCheck(!check);
  },[check]);

  const handleCheck = useCallback((id) => {
    setGoodsid(id)
  }, []);

  const goXmall = useCallback(() => {
    const { activityId, goalId } = urlParams;

    // 埋点
    recordSc({
      event: '$WebClick',
       data: {
        btn_name: '去购买按钮',
        click_name: '去购买',
        in_page_name: '报名套餐页',
        in_page_path: activityInfo?.name + '挑战-报名套餐页',
        element_status: check && goods_id ? '可点击' : '不可点击',
        ext: activityId
      }
    })

    if (!goods_id) {
      return showToast('请选择报名套餐');
    }
    if (!check) {
      return showToast('请勾选免责声明');
    }
    
    let params = {
      activity_id: parseInt(activityId),
      goods_id: goods_id,
      goal_id: goalId ? parseInt(goalId) : 0
    }

    indexService.postUserEnter(params).then((response) => {
      if (response.status == "OK") {
        // 注册电商回跳,支付成功后,跳转回报名后页面
        document.cookie = `TPART_REDIRECT_URL=https://www.codoon.com/activity/club/${activityId}; path=/; domain=codoon.com;`;
        // 跳转电商商详页
        window.location.replace(`https://xmall.codoon.com/html/item-detail.html?h_id=${goods_id}`);
        // 处理站内跳转商详replace不生效的问题
        if (isInCodoon()) {
          setTimeout(() => {
            window.history.go(-1);
          }, 3)
        }
        return
      }

      return showToast(response.description);
    });
  }, [goods_id, check])

  /* 获取套餐详情 */
  const getMyActivity = useCallback(() => {
    const { activityId } = urlParams;
    
    if (!activityId) {
      return showToast('活动id不存在');
    }

    const param = {
      activity_id: parseInt(activityId)
    };

    ActivityApi.getMyActivity(param).then((response) => {
      if (response.status == "OK") {
        const data = response.data;

        setActivityInfo(data);

        // 埋点
        recordSc({
          event: '$pageview',
          data: {
            ext: activityId,
            page_path: data.name + '挑战-报名套餐页',
            page_name: '报名套餐页'
          }
        })
      } else {
        showToast(response.description);
      }
    });
  }, [])

  return (
    <div className={PREFIX}>
      <div className={`${PREFIX}-content`}>
        {
          activityInfo?.goods_suit && activityInfo.goods_suit.map((item, index) => {
            return (
              <div className={`${PREFIX}-item`} key={index} onClick={()=> {handleCheck(item.goods_id)} }>
                <div className={`${PREFIX}-cont`}>
                  <div className={`${PREFIX}-cont-pic`}>
                    <div className={`${PREFIX}-pic`}> <img src={item.goods_pic} /></div>
                    <div className={`${PREFIX}-info`}>
                      <h3>套餐 { index+1 }</h3>
                      <div className='title'>{ item.goods_name}</div>
                      <div className='price'>
                        <div className='num'><i>￥</i>{ item.max_goods_price == item.min_goods_price ? keep2Decimal(item.max_goods_price / 100) : keep2Decimal(item.min_goods_price / 100) + '-' + keep2Decimal(item.max_goods_price / 100)}</div>
                        {item.market_price != 0 && item.market_price > item.max_goods_price ?<span>￥{keep2Decimal(item.market_price / 100)}</span> : ''}
                      </div>
                    </div>
                     {/* goods_id */}
                    <div className={`${PREFIX}-check ${goods_id == item.goods_id ? `${PREFIX}-checked` : ''}`}></div>
                  </div> 
                </div>
                <div className={`${PREFIX}-fix-info`}>
                  <img src={giftIcon} />
                  <p>选择本套餐并完成挑战可获得 <span>{ item.award_desc }</span></p>
                </div>
              </div>
            )
          })
        }
      </div>

      <div className={classNames(`${PREFIX}-btn-fixed`, {
        [`${PREFIX}-is-iphonex`]: isIosBangsDevice
       })}
      >
        <div className='btn' onClick={goXmall}>提交</div>
        <div className='desc'>
          <div className='radio-box' onClick={onSelect}>
            <div className='radio'>{ check ? <span></span> : '' }</div>
          </div>
          <a href="https://tms.codoon.com/cms/pro/ActivityRules.html">我已阅读并确认<span>免责声明</span></a>
        </div>
      </div>

      {/* Toast */}
      {toastVisible && <GlobalToast text={toastTip} />}

    </div>
  );
});

export default SignGroup;
